import { BottomSheetModal } from '@gorhom/bottom-sheet';
import React, { RefObject } from 'react';
import { StyleSheet, View } from 'react-native';
import BottomSheet from 'shared/components/vxl/BottomSheet/BottomSheet';
import Button from 'shared/components/vxl/Button/Button';
import TitleMdText from 'shared/components/vxl/typography/primary/title/TitleMdText';
import theme from 'shared/styles/theme';

interface ConfirmCancelBottomSheetProps {
  bottomSheetRef: RefObject<BottomSheetModal | null>;
  onConfirm: () => void;
  onCancel: () => void;
  confirmationText: string;
  confirmButtonLabel: string;
  cancelButtonLabel: string;
}

const ConfirmCancelBottomSheet = ({
  bottomSheetRef,
  onConfirm,
  onCancel,
  confirmationText,
  confirmButtonLabel,
  cancelButtonLabel,
}: ConfirmCancelBottomSheetProps) => {
  return (
    <BottomSheet ref={bottomSheetRef}>
      <View style={styles.bottomSheetStyle}>
        <TitleMdText>{confirmationText}</TitleMdText>
      </View>
      <View style={styles.buttonGroup}>
        <Button label={confirmButtonLabel} type="PRIMARY" onPress={onConfirm} />
        <Button label={cancelButtonLabel} type="SECONDARY" onPress={onCancel} />
      </View>
    </BottomSheet>
  );
};

const styles = StyleSheet.create({
  bottomSheetStyle: {
    gap: theme.spacing.s,
    padding: theme.spacing.m,
  },
  buttonGroup: {
    gap: theme.spacing.m,
    paddingHorizontal: theme.spacing.m,
  },
});

export default ConfirmCancelBottomSheet;
